import { configV2 } from '@sunbit-dev/common/services/config';
import { Config } from './models';
import { baseConfig, environmentsConfigs } from './configs';

class ConfigService {
  private _config: Config | undefined;

  constructor() {
    this._config = configV2.createConfig<Config>(baseConfig, environmentsConfigs);
  }

  get config() {
    return this._config;
  }

  set config(newConfig) {
    this._config = newConfig;
  }
}

const ConfigServiceInstance = new ConfigService();

export { ConfigServiceInstance as ConfigService };
